/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CALENDAR ICON — THE PERIOD OF THE WHOLE PAGE */
export const CalendarIcon = ({ size = 16 }) => (
    <Icon size={size} width={1.9}>
        <rect x="3.2" y="5.4" width="17.6" height="15.4" rx="3" />
        <path d="M3.2 10.2h17.6M8.4 3.2v4M15.6 3.2v4" />
    </Icon>
)

/* FILTER ICON — HOW MANY EXTRA CONDITIONS THE PERIOD BUTTON HOLDS */
export const FilterIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 6h18M6.5 12h11M10 18h4" />
    </Icon>
)

/* DOWNLOAD ICON — THE TWO REPORTS OF THE PERIOD */
export const DownloadIcon = ({ size = 16 }) => (
    <Icon size={size} width={2.2}>
        <path d="M12 3.6v10.8" />
        <path d="M7.6 10.4 12 14.8l4.4-4.4" />
        <path d="M4.4 18.4h15.2" />
    </Icon>
)

/* DEBIT ICON — THE MONEY THE PLAYERS PUT ON THE TABLE */
export const DebitIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 16.5l5.5-5.5 3.5 3.5L21 5.5" />
        <path d="M14.5 5.5H21v6.5" />
    </Icon>
)

/* CREDIT ICON — THE MONEY THAT WENT BACK TO THE PLAYERS */
export const CreditIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 7.5l5.5 5.5 3.5-3.5L21 18.5" />
        <path d="M14.5 18.5H21V12" />
    </Icon>
)

/* GGR ICON — A STACK OF CHIPS, WHAT STAYED IN THE HOUSE */
export const GgrIcon = ({ size = 16 }) => (
    <Icon size={size} width={1.9}>
        <ellipse cx="12" cy="6.6" rx="7.6" ry="3.1" />
        <path d="M4.4 6.6v4.9c0 1.71 3.4 3.1 7.6 3.1s7.6-1.39 7.6-3.1V6.6" />
        <path d="M4.4 11.5v4.9c0 1.71 3.4 3.1 7.6 3.1s7.6-1.39 7.6-3.1v-4.9" />
    </Icon>
)

/* TRANSACTION ICON — THE MONEY TRAVELS BOTH WAYS */
export const TransactionIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M4 9h15" />
        <path d="M15.5 5.5 19 9l-3.5 3.5" />
        <path d="M20 16H5" />
        <path d="M8.5 12.5 5 16l3.5 3.5" />
    </Icon>
)

/* ROUND ICON — ONE DEAL OF THE TABLE, TWO CARDS ON THE FELT */
export const RoundIcon = ({ size = 16 }) => (
    <Icon size={size} width={1.9}>
        <rect x="3.4" y="6" width="8.6" height="12.6" rx="2" transform="rotate(-14 7.7 12.3)" />
        <rect x="11.2" y="4.8" width="9.4" height="13.8" rx="2.2" />
    </Icon>
)

/* PROFIT ICON — THE SHARE OF THE DEBIT THAT STAYED */
export const ProfitIcon = ({ size = 16 }) => (
    <Icon size={size} width={2.2}>
        <path d="M19 5 5 19" />
        <circle cx="7.2" cy="7.2" r="2.4" />
        <circle cx="16.8" cy="16.8" r="2.4" />
    </Icon>
)

/* FIRE ICON — THE MOST PLAYED TABLE OF THE PERIOD */
export const FireIcon = ({ size = 13 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" stroke="none">
        <path d="M13.4 1.6c.4 2.5-.5 4.4-2 6-1.7 1.8-3.9 3.3-4.9 5.9-1.4 3.7.8 7.7 4.6 8.8-1-1-1.5-2.2-1.3-3.6.2-1.6 1.3-2.6 2.2-3.8.5.9.5 1.8.4 2.7 1.5-1 2.4-2.4 2.5-4.2 1.3 1.6 1.7 3.4 1.2 5.4-.3 1.3-1 2.4-2 3.4 2.9-.7 5.1-3.1 5.5-6.1.5-3.6-1.2-6.4-3.6-8.8-.9-.9-1.8-1.7-2.3-2.9-.1-.3-.2-.6-.3-.9z" />
    </svg>
)

/* CARDS ICON — AN EMPTY LIST OF GAMES */
export const CardsIcon = ({ size = 34 }) => (
    <Icon size={size} width={1.5}>
        <rect x="3" y="5.6" width="9.2" height="13.4" rx="2.2" transform="rotate(-14 7.6 12.3)" />
        <rect x="10.8" y="4.2" width="10.2" height="15" rx="2.4" />
        <path d="M15.9 8.4c-1.1 1-1.8 1.7-1.8 2.5 0 .62.45 1.08 1.08 1.08.34 0 .58-.14.76-.34-.09.62-.36 1.08-.72 1.44h1.44c-.36-.36-.63-.82-.72-1.44.18.2.42.34.76.34.63 0 1.08-.46 1.08-1.08 0-.8-.7-1.5-1.8-2.5z" />
    </Icon>
)

/* NOTE ICON — THE HEAD OF THE NOTES MODAL */
export const NoteIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <path d="M15.5 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L15.5 3z" />
        <path d="M15 3v5h5" />
        <path d="M8.5 12.5h7M8.5 16h4.5" />
    </Icon>
)

/* CLOSE ICON — EVERY MODAL OF THE PAGE CLOSES BY IT */
export const CloseIcon = ({ size = 14 }) => (
    <Icon size={size} width={2.4}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* SEARCH ICON — THE INNER SEARCH OF A LIST */
export const SearchIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.5-3.5" />
    </Icon>
)

/* TABLE ICON — A GAME OF THE FILTER */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4" width="18" height="16" rx="2.5" />
        <path d="M3 9.5h18M9 9.5V20" />
    </Icon>
)

/* CLOCK ICON — THE TIME OF THE LAST NOTE */
export const ClockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.5V12l3 1.8" />
    </Icon>
)

/* OPERATOR ICON — ONE OPERATOR OF THE BREAKDOWN */
export const OperatorIcon = ({ size = 16 }) => (
    <Icon size={size} width={1.9}>
        <circle cx="12" cy="8" r="3.6" />
        <path d="M4.6 20c0-3.6 3.3-6.2 7.4-6.2s7.4 2.6 7.4 6.2" />
    </Icon>
)

/* STUDIO ICON — ONE STUDIO OF AN OPERATOR */
export const StudioIcon = ({ size = 14 }) => (
    <Icon size={size} width={1.9}>
        <path d="M3.4 20V9.4l8.6-5.4 8.6 5.4V20" />
        <path d="M9.4 20v-5.6h5.2V20" />
    </Icon>
)

/* CHEVRON ICON — THE GAMES OF A STUDIO OPEN AND CLOSE */
export const ChevronIcon = ({ size = 13 }) => (
    <Icon size={size} width={2.4}>
        <path d="m7.5 10 4.5 4.5L16.5 10" />
    </Icon>
)
